module.exports = __webpack_public_path__ + "static/media/Logo.a2f72e79.svg";